import React from "react";
import {Image} from 'react-bootstrap';

import "./CoreAdvantage.css";

import icon_advantage from "../../asset/images/icon_advantage.webp";
import icon_advantage_01 from "../../asset/images/icon_advantage_01.png";
import icon_advantage_02 from "../../asset/images/icon_advantage_02.png";
import icon_advantage_03 from "../../asset/images/icon_advantage_03.png";
import icon_advantage_04 from "../../asset/images/icon_advantage_04.png";

// 核心优势
class CoreAdvantage extends React.Component {
  render() {
    return (
      <div className="advantage">
        <Image src={icon_advantage} className="advantage_ico" />
        <div className="advantage_cards">
          <div className="advantage_card">
            <Image src={icon_advantage_01} className="advantage_card_ico" />
            <div className="advantage_card_word">
              <span className="advantage_card_title">
                强大综合能源管理平台
              </span>
              <h3 className="advantage_card_rectangle"> </h3>
              <p className="advantage_card_paragraph">
                能源管理平台之于涵智博雅正如树冠之于树木，基于云生态圈不断吸收阳光雨露，让所有接入涵智博雅云端生态圈的能源管控节点形成有机统一整体，通过功能强大的数据分析能力，助力工厂信息化升级
              </p>
            </div>
          </div>
          <div className="advantage_card">
            <Image src={icon_advantage_02} className="advantage_card_ico" />
            <div className="advantage_card_word">
              <span className="advantage_card_title">
                稳定物联网平台
              </span>
              <h3 className="advantage_card_rectangle"> </h3>
              <p className="advantage_card_paragraph">
                凭借多年深耕工业物联网与节能技术的经历，涵智博雅具备为多行业多类型企业提供极致稳定物联网服务的技术能力，实现真正意义上的“物物相连”，通过搭建系统化的物联网平台，不断优化系统性能，提高能源利用效率
              </p>
            </div>
          </div>
          <div className="advantage_card">
            <Image src={icon_advantage_03} className="advantage_card_ico" />
            <div className="advantage_card_word">
              <span className="advantage_card_title">
                高效节能改造服务
              </span>
              <h3 className="advantage_card_rectangle"> </h3>
              <p className="advantage_card_paragraph">
                作为企业的核心竞争力，先进高效的节能技术是整个涵智博雅体系的支柱，坚实可靠的技术能力为多体系多维度的综合能源服务提供强有力的支持
              </p>
            </div>
          </div>
          <div className="advantage_card">
            <Image src={icon_advantage_04} className="advantage_card_ico" />
            <div className="advantage_card_word">
              <span className="advantage_card_title">
               领先技术研发能力
              </span>
              <h3 className="advantage_card_rectangle"> </h3>
              <p className="advantage_card_paragraph">
                在涵智博雅的节能服务生命体系中，不断创新的技术研发能力是涵智博雅这颗能源服务之树不断生长壮大的源泉，通过与国内优秀的科研院校进行产学研合作，不断探索行业前沿领域，为企业的发展源源不断注入养分
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CoreAdvantage
